import { useTranslation } from 'react-i18next';

import './columns-headings.scss';

export const ColumnsHeadings = () => {
  const { t } = useTranslation();

  // @TODO: leave fist element empty for correct grid layout. Refactor after RFS2025
  const HEADINGS = ['', t('Status'), t('Feedback'), t('Due date'), t('Action')];

  return (
    <div className="ms-columns-headings">
      {HEADINGS.map((headingLabel) => (
        <div key={headingLabel} className="heading">
          {headingLabel}
        </div>
      ))}
    </div>
  );
};
